// Решение «обновить сейчас или при следующем переходе» для открытого
// приложения после деплоя (components/version-watch.tsx).
//
// Перезагрузка посреди урока сбросила бы шаг, поэтому сразу перезагружаем
// только после долгой паузы в фоне; после короткой новая версия приедет
// при следующем переходе по ссылке.

export const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID ?? ''
export const LONG_AWAY_MS = 30 * 60 * 1000
export const CHECK_THROTTLE_MS = 60 * 1000

export type StaleAction = 'none' | 'reload' | 'on-next-link'

export function staleAction(current: string, server: string | null | undefined, awayMs: number): StaleAction {
  if (!current || !server || server === current) return 'none'
  return awayMs >= LONG_AWAY_MS ? 'reload' : 'on-next-link'
}
